// src/data/news.js
export const NEWS = [
  {
    date: "2026-06-06",
    title: "サイトをオープンしました",
  },
  {
    date: "2026-06-16",
    title: "統計ページを追加しました",
    detail: `
      各くじの配当金・当選口数の統計データを確認できる統計ページを追加しました。<br>
      <a href="/loto6/stats">ロト6 統計</a>・
      <a href="/loto7/stats">ロト7 統計</a>・
      <a href="/miniloto/stats">ミニロト 統計</a>・
      <a href="/numbers3/stats">ナンバーズ3 統計</a>・
      <a href="/numbers4/stats">ナンバーズ4 統計</a>・
      <a href="/bingo5/stats">ビンゴ5 統計</a>・
      <a href="/qoochan/stats">着せかえクーちゃん 統計</a>
    `,
  },
  {
    date: "2026-06-21",
    title: "AI解析機能を追加しました",
    detail:
      "各くじの詳細ページにAI解析コメントを追加しました。配当金分析・数字パターン・類似過去回などを確認できます。",
  },
  {
    date: "2026-08-30",
    title: "詳細ページに「出目が似ている過去の抽選」を追加しました",
    detail:
      "各くじの詳細ページに、その回と当選数字の並びが似ている過去の抽選を、似ている順に最大5件表示するセクションを追加しました。本数字の一致数や並べ替え一致などを手がかりに、過去データを掘り下げてご覧いただけます。",
  },
];
